module.exports = __webpack_public_path__ + "img/微信图片_20251027135745_1190_62.01b5093e.jpg";